<div class="modal-content custom-modal">
  <!-- HEADER -->
  <div class="modal-header border-bottom-0">
    <h2 class="modal-title w-100 text-center fw-bold title-modal">
      Registro de asistencia
    </h2>
  </div>

  <!-- BODY -->
  <div class="modal-body">
    <p class="subtitle">
      {{
        showToggle
          ? isFormGuestNumberPerson
            ? "Favor de capturar tu número de colaborador"
            : "Favor de capturar tu CURP"
          : "Favor de capturar el número de colaborador"
      }}
    </p>

    <div class="mb-4">
      <input
        [(ngModel)]="inputText"
        [ngModelOptions]="{ standalone: true }"
        (input)="regexValidation()"
        class="form-control custom-input"
        type="text"
        [attr.maxlength]="isFormGuestNumberPerson ? '8' : '18'"
        [placeholder]="
          isFormGuestNumberPerson ? 'Número de colaborador' : 'CURP'
        " />
    </div>

    <!-- BOTONES -->
    <div
      class="d-flex justify-content-center align-items-center gap-3 flex-wrap">
      <button
        [disabled]="!isValidInputForm"
        (click)="submit()"
        class="btn btn-primario btn-sm-custom">
        <span> Registrar asistencia </span>
      </button>

      <span *ngIf="showToggle" class="separator">ó</span>

      <button
        *ngIf="showToggle"
        (click)="changeForm()"
        class="btn btn-secondary-cap btn-sm-custom">
        {{ buttonText }}
      </button>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="modal-footer border-top-0 justify-content-end">
    <button
      class="btn btn-secondary-cap btn-sm-custom"
      (click)="onCloseModal()">
      Cerrar
    </button>
  </div>
</div>
